import DOMPurify from 'isomorphic-dompurify';
import { forOwn, map, isArray } from "lodash-es";

export const Utils = () => {

  const preventXSSAttacks = (content: string) => DOMPurify.sanitize(content);

  const generateRandomString = (length: number) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  };

  const secureVariables = (variables) => {
    return forOwn(variables, (value, key, object) => {
      if (Array.isArray(value)) {
        object[key] = map(value, (item) => isArray(item) ? item : DOMPurify.sanitize(item));
      } else {
        object[key] = DOMPurify.sanitize(value);
      }
    });
  };
  const preventSqlAttacks = (content:string) => {
    const sqlKeywords = [
      "SELECT", "INSERT", "UPDATE", "DELETE",
      "FROM", "WHERE", "AND", "OR", "UNION",
      "JOIN", "ORDER BY", "GROUP BY"
      ]; 
      const pattern = new RegExp(`\\b(${sqlKeywords.join("|")})\\b`, "i");
      if (pattern.test(content)) {
        return true;
      } else {
        return false;
      }
  };
  return {
    preventXSSAttacks,
    generateRandomString,
    secureVariables,
    preventSqlAttacks
  };
};

export default Utils;
